import React from 'react';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

const cases = [
  {
    metric: '3x',
    label: 'The weekly pipeline without adding headcount.',
    company: 'Meritt',
    emoji: '🏢',
    desc: 'Meritt grew pipeline from $100K to $300K per week by fixing their data. Same team, three times the output.',
    color: 'from-orange-50 to-amber-50',
    border: 'border-orange-200',
    badge: 'bg-orange-100 text-orange-700',
  },
  {
    metric: '$1M',
    label: 'ARR in 18 months on trusted data.',
    company: 'Stack Optimize',
    emoji: '🚀',
    desc: 'Felix and Penn Frank scaled to $1M ARR using one data provider for client campaigns and internal outbound.',
    color: 'from-green-50 to-emerald-50',
    border: 'border-green-200',
    badge: 'bg-green-100 text-green-700',
  },
  {
    metric: '22%',
    label: 'Cold-call connect rate using verified direct mobiles.',
    company: 'Founder Led Sales',
    emoji: '📞',
    desc: 'Connect rate jumped from 5% to 22%. Stopped fighting assistants, started reaching decision-makers directly.',
    color: 'from-blue-50 to-indigo-50',
    border: 'border-blue-200',
    badge: 'bg-blue-100 text-blue-700',
  },
  {
    metric: '2.5x',
    label: 'Faster for new reps to hit quota.',
    company: 'GreyScout',
    emoji: '⚡',
    desc: 'New SDRs ramped in 4 weeks instead of 8–10. They had 15–20 conversations in week one instead of 3–4.',
    color: 'from-purple-50 to-violet-50',
    border: 'border-purple-200',
    badge: 'bg-purple-100 text-purple-700',
  },
  {
    metric: '300%',
    label: 'Increase in email response rate.',
    company: 'Snyk',
    emoji: '🔒',
    desc: 'Pete Lipton got 50 AEs prospecting 4–6 hours per week. Response rates tripled from 0.9% because the data actually worked.',
    color: 'from-pink-50 to-rose-50',
    border: 'border-pink-200',
    badge: 'bg-pink-100 text-pink-700',
  },
];

export default function CaseStudies() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-2">You're in good company</p>
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900">Meet the companies generating more revenue with Director Discovery</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cases.map((c) => (
            <div
              key={c.company}
              className={`bg-gradient-to-br ${c.color} rounded-2xl border ${c.border} p-6 flex flex-col group hover:shadow-md transition-shadow`}
            >
              <div className="flex items-start justify-between mb-4">
                <div>
                  <p className="text-4xl font-extrabold text-gray-900 leading-none mb-1">{c.metric}</p>
                  <p className="text-sm font-medium text-gray-600 max-w-xs">{c.label}</p>
                </div>
                <span className="text-3xl">{c.emoji}</span>
              </div>

              <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold w-fit mb-3 ${c.badge}`}>
                {c.company}
              </div>

              <p className="text-sm text-gray-600 leading-relaxed flex-1 mb-5">{c.desc}</p>

              <a href="#" className="flex items-center gap-1 text-sm font-semibold text-indigo-600 hover:gap-2 transition-all group-hover:text-indigo-700">
                Learn more <ArrowRightIcon className="w-4 h-4" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
